import { render } from "./AdSection1.vue?vue&type=template&id=4d1bceb8&scoped=true"
import script from "./AdSection1.vue?vue&type=script&lang=js"
export * from "./AdSection1.vue?vue&type=script&lang=js"

import "./AdSection1.vue?vue&type=style&index=0&id=4d1bceb8&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4d1bceb8"]])

export default __exports__